import React from 'react';
import PropTypes from 'prop-types';
import './styles/search_dropdown.scss';

class ListItem extends React.Component {
  getUrl() {
    const { slug, type } = this.props;
    switch (type) {
      case 'organization':
        return `/organizations/${slug}`;
      case 'portal':
        return `/portals/${slug}`;
      case 'brandguide':
        return `https://brandguide.brandfolder.com/${slug}`;
      default:
        return `/${slug}`;
    }
  }

  render() {
    const { name, type } = this.props;

    return (
      <li
        className={`search-dropdown__item search-dropdown__item--${type}`}
        data-testid="search-dropdown-list-item"
      >
        {`${type}` === 'brandfolder'
          && <span className={`bff-grid-view search-dropdown__item--${type}--icon`} aria-hidden />
        }
        {`${type}` === 'brandguide'
          && <span className={`bff-brand-guide search-dropdown__item--${type}--icon`} aria-hidden />
        }
        {`${type}` === 'portal'
          && <span className={`bff-portal search-dropdown__item--${type}--icon`} aria-hidden />
        }
        <a
          href={this.getUrl()}
          data-testid="search-dropdown-list-item-link"
          aria-label={`${name} ${type}`}
        >
          {name}
        </a>
        {`${type}` === 'organization'
          && <span className="org-label" data-testid="search-dropdown-org-label" aria-hidden>Org</span>
        }
      </li>
    );
  }
}

ListItem.propTypes = {
  name: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
  type: PropTypes.oneOf([
    'organization',
    'brandfolder',
    'collections',
    'portal',
    'brandguide',
  ]).isRequired
};

export default ListItem;
